import * as React from "react"
import type { SVGProps } from "react"
const SvgRecommendationIncoming = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M16.05 5.1a7.8 7.8 0 0 0-6.1-.84A7.7 7.7 0 0 0 5.08 8L5 8.15l-.33-1.23a1 1 0 0 0-.46-.59 1 1 0 0 0-.75-.1 1 1 0 0 0-.59.46 1 1 0 0 0-.1.74L3.7 11a.96.96 0 0 0 1.22.7l3.55-.96a1 1 0 0 0 .59-.46q.22-.37.1-.75a1 1 0 0 0-.46-.59 1 1 0 0 0-.74-.1l-1.23.32L6.8 9a5.8 5.8 0 0 1 3.66-2.8 5.9 5.9 0 0 1 5.81 1.6q.3.32.7.38t.77-.17a.9.9 0 0 0 .17-1.4q-.39-.46-.87-.84a8 8 0 0 0-1-.67" />
    <path
      d="M8.3 16.73a6.2 6.2 0 0 0 5.24 1.07 5.8 5.8 0 0 0 3.65-2.8l.08-.15-1.22.33a1 1 0 0 1-.75-.11 1 1 0 0 1-.47-.6 1 1 0 0 1 .12-.74q.2-.36.58-.47l3.55-.95a.96.96 0 0 1 1.21.7l.96 3.55q.09.38-.12.75a1 1 0 0 1-.58.47 1 1 0 0 1-.75-.11 1 1 0 0 1-.47-.6l-.32-1.22-.1.15a7.7 7.7 0 0 1-4.86 3.74 7.8 7.8 0 0 1-7.1-1.54q-.47-.38-.9-.86a1 1 0 0 1-.22-.72q.05-.43.4-.64.37-.22.78-.16.4.06.72.38.25.3.57.53"
      opacity={0.25}
    />
  </svg>
)
export default SvgRecommendationIncoming
